import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { useAuth } from "@/lib/auth";
import {
  LayoutDashboard, FileText, ClipboardList, Layers, Package,
  Factory, Printer, Truck, Users, Settings, LogOut, Home, Bell,
  Calendar, Clock, ClipboardCheck, Boxes, Download, Plug,
} from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, exact: true, testid: "admin-nav-dashboard" },
  { to: "/admin/orcamentos", label: "Orçamentos", icon: FileText, testid: "admin-nav-quotes" },
  { to: "/admin/propostas", label: "Propostas", icon: ClipboardList, testid: "admin-nav-proposals" },
  { to: "/admin/projetos", label: "Projetos", icon: Layers, testid: "admin-nav-projects" },
  { to: "/admin/encomendas", label: "Encomendas", icon: Package, testid: "admin-nav-orders" },
  { to: "/admin/producao", label: "Produção · Kanban", icon: Factory, testid: "admin-nav-production" },
  { to: "/admin/planeamento", label: "Planeamento", icon: Calendar, testid: "admin-nav-schedule" },
  { to: "/admin/impressoras", label: "Impressoras", icon: Printer, testid: "admin-nav-printers" },
  { to: "/admin/materiais", label: "Materiais", icon: Layers, testid: "admin-nav-materials" },
  { to: "/admin/consumos", label: "Consumos", icon: Boxes, testid: "admin-nav-consumption" },
  { to: "/admin/qualidade", label: "Qualidade", icon: ClipboardCheck, testid: "admin-nav-quality" },
  { to: "/admin/registo-horas", label: "Registo de horas", icon: Clock, testid: "admin-nav-time" },
  { to: "/admin/produtos", label: "Produtos", icon: Package, testid: "admin-nav-products" },
  { to: "/admin/expedicoes", label: "Expedições", icon: Truck, testid: "admin-nav-shipments" },
  { to: "/admin/clientes", label: "Clientes", icon: Users, testid: "admin-nav-customers" },
  { to: "/admin/exports", label: "Relatórios", icon: Download, testid: "admin-nav-exports" },
  { to: "/admin/notificacoes", label: "Notificações", icon: Bell, testid: "admin-nav-notifications" },
  { to: "/admin/integracoes", label: "Integrações", icon: Plug, testid: "admin-nav-integrations" },
  { to: "/admin/definicoes", label: "Definições", icon: Settings, testid: "admin-nav-settings" },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex bg-background">
      <aside className="hidden lg:flex flex-col w-64 border-r border-border bg-card">
        <div className="p-5 border-b border-border">
          <Logo size={64} />
          <p className="tech-label mt-3">Painel administrativo</p>
        </div>
        <nav className="p-3 flex-1 overflow-y-auto">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.exact}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded text-sm mb-0.5 transition-colors ${
                  isActive ? "bg-brand text-white" : "text-foreground/80 hover:bg-secondary"
                }`
              }
            >
              <l.icon size={16} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-border">
          <div className="text-sm font-medium truncate">{user?.name}</div>
          <div className="text-xs text-muted-foreground mono uppercase">{user?.role}</div>
          <div className="mt-3 flex items-center gap-2">
            <Link to="/" className="text-xs flex items-center gap-1 text-muted-foreground hover:text-foreground" data-testid="admin-nav-public">
              <Home size={12} /> Site
            </Link>
            <button onClick={logout} className="text-xs flex items-center gap-1 text-muted-foreground hover:text-foreground" data-testid="admin-nav-logout">
              <LogOut size={12} /> Sair
            </button>
          </div>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <header className="border-b border-border bg-card/60 backdrop-blur px-6 h-14 flex items-center justify-between lg:hidden">
          <Logo size={18} />
          <button onClick={logout} className="text-xs">Sair</button>
        </header>
        <div className="p-6 lg:p-8">{children}</div>
      </div>
    </div>
  );
}
